<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
        <TableView
      :headers="headers"
      :items="tableData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :bodyFilter="true"
      :refreshTable="getData"
      item-key="id"
      table-height="70vh"
    >     
      <template v-slot:body-prepend>
        <BodyFilterView
          :filters="filterData"
          :search.sync="search"
          :options.sync="options"
          @getDataParent="getData"
        />
      </template>
    </TableView>

  </v-card>
</template>

<script>
import changeLogFeeMixin from '../../components/setting-fee/change-log-spe/changeLogFeeMixin';



export default {
  mixins: [ changeLogFeeMixin ],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    BodyFilterView: () => import("../../components/@drontVue/components/BodyFilter"),
  }
};
</script>